module.exports = __webpack_public_path__ + "static/media/intro_black_caps.e414db42.TTF";